export default () => ({
  title: "",
  titleEn: "",
  key: "",
  permissionRooms:[],
  permissionRoom:null,
  permissionRoomsToEdit: '',
  status: '',
  total: "",
});
